import { enableProdMode, LOCALE_ID, ErrorHandler, importProvidersFrom } from '@angular/core';

//import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { LoginComponent } from 'src/app/shared/login/login.component';
import { DebugComponent } from './app/shared/dev-debug/debug.component';
import { TestComponent } from './app/test/test.component';
import { provideRouter } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SharedModule } from './app/shared/shared.module';
import { CeviSharedModule } from './app/cevi-shared/cevi-shared.module';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { APP_BASE_HREF, registerLocaleData } from '@angular/common';
import { ErrordialogService } from './app/cevi-shared/error-dialog/errordialog.service';
import { CustomErrorHandler } from './app/shared/custom-error-handler';
import localeNlBe from '@angular/common/locales/nl-be';

import { dashboardRoutes } from 'src/app/dashboard/dashboard.module';
import { agendapuntRoutes } from './app/agendapunt/agendapunt.module';
import { detailZittingRoutes } from './app/detail-zitting/detail-zitting.module';
import { zoekenRoutes } from 'src/app/zoeken/zoeken.module';
import { prikbordRoutes } from 'src/app/prikbord/prikbord.module';
import { archiefRoutes } from 'src/app/archief/archief.module';
import { zoekenZittingRoutes } from 'src/app/zoeken-zitting/zoeken-zitting.module';
import { notitieRoutes } from 'src/app/notities/notities.module';

if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeNlBe);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CeviSharedModule.forRoot(), SharedModule.forRoot(), FormsModule),
        { provide: LOCALE_ID, useValue: 'nl-BE' },
        { provide: ErrorHandler, useClass: CustomErrorHandler, deps: [ErrordialogService] },
        { provide: APP_BASE_HREF, useValue: new URL(document.getElementsByTagName('base')[0]['href']).pathname },
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter([
            { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
            { path: '', children: dashboardRoutes},
            { path: '', children: detailZittingRoutes },
            { path: '', children: agendapuntRoutes },
            { path: '', children: zoekenRoutes},
            { path: '', children: prikbordRoutes },
            { path: '', children: archiefRoutes },
            { path: '', children: zoekenZittingRoutes},
            { path: '', children: notitieRoutes},
            { path: 'home', component: TestComponent },
            { path: 'gebruiker', loadChildren: () => import("./app/gebruiker/gebruiker.module").then(m => m.routes) },
            { path: 'document', loadChildren: () => import("./app/document-viewer-page/document-viewer.module").then(m => m.routes) },
            { path: 'debug', component: DebugComponent },
            { path: 'login', component: LoginComponent },
            
        ])
    ]
})
  .catch(err => console.error(err));

  declare var __webpack_public_path__;
  __webpack_public_path__ = 'dist/';
